import React from 'react'
import { Link } from 'react-router-dom'
import { Card, Col, Row, Space, Tag, Typography } from 'antd'
import { ReactComponent as Illustration } from '../assets/illus.svg'
import useRegion from '../hooks/useRegion'
import useRecent from '../hooks/useRecent'
import { entityPath } from '../routes'
import { kindLabels, sectionOfKind, sections } from '../sections'
import { timeAgo } from '../util/format'
import ActionCard from './ui/ActionCard'
import SectionIcon from './ui/SectionIcon'
const { Title, Paragraph } = Typography

const steps = [
    { title: 'Create', text: 'Make a collection, funding or deduction with test data.' },
    { title: 'Find', text: 'Enter an ID, or pick one from your recent list.' },
    { title: 'Change status', text: 'Pick the next status and confirm. Repeat to walk through the whole lifecycle.' },
]

const Home: React.FC = () => {
    const region = useRegion()
    const recent = useRecent(undefined, 6)

    return (
        <>
            <section className="hero">
                <div>
                    <Title level={1}>Wallex Simulator</Title>
                    <Paragraph className="hero-subtitle">Create test transactions and move them through every status, just like they would in Wallex.</Paragraph>
                    <Space wrap>
                        <Tag>Region {region}</Tag>
                    </Space>
                </div>
                <Illustration className="hero-illustration" aria-hidden />
            </section>

            <Title level={4} className="home-heading">
                What do you want to simulate?
            </Title>
            <Row gutter={[16, 16]}>
                {sections.map((section) => (
                    <Col key={section.key} xs={24} sm={12} lg={8}>
                        <ActionCard to={section.root} icon={<SectionIcon section={section} size={26} />} title={section.title} description={section.summary} />
                    </Col>
                ))}
            </Row>

            {recent.length > 0 && (
                <>
                    <Title level={4} className="home-heading">
                        Recently used
                    </Title>
                    <Card bodyStyle={{ padding: 0 }}>
                        {recent.map((entry) => (
                            <Link key={`${entry.kind}:${entry.id}`} to={entityPath(entry.kind, entry.id)} className="recent-row">
                                <span className="recent-row-icon">
                                    <SectionIcon section={sectionOfKind(entry.kind)} size={22} />
                                </span>
                                <span className="recent-row-main">
                                    <span className="recent-row-id">{entry.id}</span>
                                    <span className="recent-row-meta">{[kindLabels[entry.kind], entry.label].filter(Boolean).join(' · ')}</span>
                                </span>
                                <span className="recent-row-meta">{timeAgo(entry.at)}</span>
                            </Link>
                        ))}
                    </Card>
                </>
            )}

            <Title level={4} className="home-heading">
                How it works
            </Title>
            <Card>
                <Row gutter={[24, 16]}>
                    {steps.map((step, index) => (
                        <Col key={step.title} xs={24} md={8}>
                            <div className="how-step">
                                <span className="how-step-number">{index + 1}</span>
                                <div>
                                    <div className="how-step-title">{step.title}</div>
                                    <div className="how-step-text">{step.text}</div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Card>
        </>
    )
}

export default Home
